import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetQuestionnairesForVenturesAndLabelQuery, useDeleteQuestionnaireAndUserInputsMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'DelEsgReports',
  props: {
    selected: null
  },
  emits: ['delete-complete'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var inputs = computed(function () {
      return {
        ventureIds: props.selected.map(function (s) {
          return s.ventureId;
        }),
        label: 'ESG'
      };
    });
    var _useGetQuestionnaires = useGetQuestionnairesForVenturesAndLabelQuery(inputs),
      refetch = _useGetQuestionnaires.refetch;
    var selectedIds = ref([]);
    var _useDeleteQuestionnai = useDeleteQuestionnaireAndUserInputsMutation(),
      mutate = _useDeleteQuestionnai.mutate,
      delLoading = _useDeleteQuestionnai.loading;
    var handleDelete = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return mutate({
                questionnaireIds: selectedIds.value
              });
            case 2:
              _context.next = 4;
              return refetch();
            case 4:
              emit('delete-complete');
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleDelete() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      inputs: inputs,
      refetch: refetch,
      selectedIds: selectedIds,
      mutate: mutate,
      delLoading: delLoading,
      handleDelete: handleDelete
    };
  }
});